import _ from 'lodash'
import { fetch, put, post} from '@/base-http'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import ModerationVote from '@/modules/cms/modules/moderation/model/ModerationVote'

export interface VoteSaveResult {
    vote: ModerationVote,
    contentIsApproved: boolean
}

/**
 * Retorna la lista de votos de moderación asociados a un determinado contenido
 *
 * @param contentType
 * @param contentId
 */
export async function getVotes (contentType: string, contentId: string | number) {
    const data: KeyValuePair[] = await fetch('cms/moderation/votes', {
        params: { contentType, contentId },
    })

    return data.map(v => ModerationVote.deserialize(v))
}

/**
 * Registra un nuevo voto de moderación en el servidor
 *
 * @param vote
 */
export async function createVote (vote: ModerationVote): Promise<VoteSaveResult> {
    try {
        const data = await post('/cms/moderation/vote', vote.serialize())

        return {
            vote: ModerationVote.deserialize(data.vote),
            contentIsApproved: data.content_is_approved,
        }
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}



/**
 * Actualiza un voto de moderación en el servidor
 * @param vote
 */
export async function updateVote (vote: ModerationVote): Promise<VoteSaveResult> {
    if (vote.isNew) {
        throw new Error('No se puede actualizar un voto que todavía no ha sido registrado')
    }

    const data = await put(`cms/moderation/vote/${vote.id}`, {
        comment: vote.comment,
        approved: vote.approved,
    })

    return {
        vote: ModerationVote.deserialize(data.vote),
        contentIsApproved: data.content_is_approved,
    }
}

/**
 * Obtiene el estado del permisos de moderación para un determinado usuario
 *
 * @param id
 */
export async function getModeratorPermissionStatus (id: number) {
    const data = await fetch('cms/moderation/moderator-permission-status', {
        params: { id },
    })

    return (data.status || false) as boolean
}
